import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenField, ScreenFieldProps } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const LikelihoodLevel = ({ codeItem, updateByKey, resetValidation, translation, readOnlyConfig, validation }: ScreenFieldProps) => {

  const onChange = (value: number) => {
    resetValidation(ScreenField.likelihoodLevel);
    updateByKey(ScreenField.likelihoodLevel, value);
  };

  const likelihoodLevelValidation = !!validation && !!validation[ScreenField.likelihoodLevel]
    ? validation[ScreenField.likelihoodLevel] : undefined;

  const readOnly = readOnlyConfig?.[ReadOnlyType.all];

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="code_likelihood_level"
      readOnly={readOnly}
      label={translation ? { text: translation.likelihood_level, required: !readOnly } : undefined}
      value={codeItem && codeItem.level}
      onChange={onChange}
      useThousand=" "
      maxValue={999999999}
      validation={likelihoodLevelValidation}
      required={true}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
